const getVariableDefinitions = (definitions) => {
  if (!definitions) return {}

  return definitions.reduce((agg, curr) => {
    let vars = [...agg]

    curr.variableDefinitions?.forEach((v) => {
      vars.push({
        name: v.variable.name.value,
        required: !v.defaultValue && v.type.kind === 'NonNullType',
      })
    })
    return vars
  }, [])
}

const isEachRequiredVariablePresent = (requiredVariables, variables) => {
  const missingRequiredVariable = requiredVariables.find(
    (v) => v.required && !variables[v.name]
  )

  return !missingRequiredVariable
}

export const shouldExecuteQuery = (query, variables = {}) => {
  const variableDefinitions = getVariableDefinitions(query.definitions)
  const requiredVariables = variableDefinitions.filter((v) => v.required)

  // if more required variables than those supplied, something's wrong
  if (requiredVariables > Object.keys(variables).length) {
    return false
  }

  // ensure we have a value for each required variable
  return isEachRequiredVariablePresent(requiredVariables, variables)
}
